import React, { useState } from 'react'
import classnames from 'classnames'
import { RemoveScroll } from 'react-remove-scroll'
import { Navigation } from './Navigation'
import { Link } from './Link'
import { logo } from '../images'

const Header = () => {
  const [menuActive, setMenuActive] = useState(false)

  function handleButton() {
    setMenuActive(!menuActive)
  }

  function closeMenu() {
    setMenuActive(false)
  }

  return (
    <header className="sitewide-header">
      <div className={classnames('header-top', { 'menu-active': menuActive })}>
        <Link to="/">
          <img src={logo} alt="Dr. Nneka E. Onyezia, Ph.D" width={185} height={22} />
        </Link>
        <div className="wide-nav">
          <Navigation />
        </div>
        <div className="mobile-nav">
          <button
            className={classnames('hamburger', 'hamburger--slider', { 'is-active': menuActive })}
            type="button"
            onClick={handleButton}
            aria-label={menuActive ? 'Close menu' : 'Open menu'}
            aria-expanded={menuActive}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
          {menuActive && (
            <RemoveScroll removeScrollBar={false}>
              {' '}
              <Navigation closeMenu={closeMenu} />{' '}
            </RemoveScroll>
          )}
        </div>
      </div>
    </header>
  )
}

export { Header }
